import { useEffect } from "react"

import { useParams } from "react-router-dom"

import { NavigationOrigins, useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { MODULE_DOCUMENTS } from "../../constants/modules"
import { useElementQuery } from "../../hooks/queries/useElementQuery"

export const DocumentValidator = (props) => {

    const { children } = props
    const navigate = useNavigateWithSearchParams()

    const { attachmentType, attachmentId, road } = useParams()
    const { data, isLoading, isError } = useElementQuery(attachmentType, attachmentId)

    useEffect(() => {
        if (!isLoading && (isError || !data)) {
            if (road) {
                navigate(`../${MODULE_DOCUMENTS}/${road}`, { replace: true, navigationOrigin: NavigationOrigins.ROAD_FROM_BACK_DETAIL })
            } else {
                navigate(`../${MODULE_DOCUMENTS}`, { replace: true, navigationOrigin: NavigationOrigins.NONE })
            }
        }
    }, [data, isError, isLoading, road, navigate])

    return children
}